/**
 * Shopify Global Utilities
 * Based on Shopify Dawn theme
 */

const MONEY_DECIMALS_BY_CURRENCY = { OMR: 3, BHD: 3, KWD: 3, JOD: 3 };

function formatStoreMoney(cents) {
  const config = window.storeConfig || {};
  const format = config.moneyFormat || '';
  const currency = config.currency || '';

  let decimals = MONEY_DECIMALS_BY_CURRENCY[currency] || 2;
  if (format.indexOf('no_decimals') !== -1) {
    decimals = 0;
  }

  const useCommaDecimal = format.indexOf('amount_with_comma_separator') !== -1;
  const thousands = useCommaDecimal ? '.' : ',';
  const decimalMark = useCommaDecimal ? ',' : '.';

  const parts = ((cents || 0) / 100).toFixed(decimals).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
  const value = parts.length > 1 ? parts[0] + decimalMark + parts[1] : parts[0];

  return currency ? `${value} ${currency}` : value;
}

// Fetch configuration helper
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

// Debounce helper
function debounce(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

// Routes configuration
window.routes = window.routes || {};
window.routes.cart_add_url = window.routes.cart_add_url || '/cart/add.js';
window.routes.cart_change_url = window.routes.cart_change_url || '/cart/change.js';
window.routes.cart_update_url = window.routes.cart_update_url || '/cart/update.js';
window.routes.cart_url = window.routes.cart_url || '/cart';

// Shopify configuration
window.Shopify = window.Shopify || {};
window.Shopify.routes = window.Shopify.routes || {};
window.Shopify.routes.root = '/';

